import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserProfile.scss'
import {Row, Col, Modal} from 'react-bootstrap'
import AdviserProfileWorkExperienceEditor from '../AdviserProfileWorkExperienceEditor/AdviserProfileWorkExperienceEditor'
import AdviserProfileBlurbEditor from '../AdviserProfileBlurbEditor/AdviserProfileBlurbEditor'
import AdviserProfileEducationEditor from '../AdviserProfileEducationEditor/AdviserProfileEducationEditor'
import AdviserProfileInvestmentMinimumsEditor from '../AdviserProfileInvestmentMinimumsEditor/AdviserProfileInvestmentMinimumsEditor'
import AdviserProfileLanguagePreferencesEditor from '../AdviserProfileLanguagePreferencesEditor/AdviserProfileLanguagePreferencesEditor'
import AdviserProfileAreasOfSpecialisationEditor from '../AdviserProfileAreasOfSpecialisationEditor/AdviserProfileAreasOfSpecialisationEditor'
import AdviserProfileClientTypesEditor from '../AdviserProfileClientTypesEditor/AdviserProfileClientTypesEditor'
import AdviserProfileSubmitForApproval from '../AdviserProfileSubmitForApproval/AdviserProfileSubmitForApproval'
import AdviserProfileConflictDeclarationsEditor from '../AdviserProfileConflictDeclarationsEditor/AdviserProfileConflictDeclarationsEditor'
import AdviserProfileContactDetailsEditor from '../AdviserProfileContactDetailsEditor/AdviserProfileContactDetailsEditor'
import AdviserProfilePicturesEditor from '../AdviserProfilePicturesEditor'
import EditButton from '../../../common/forms/EditButton'
import EditProfileButton from '../../../common/forms/EditProfileButton'
import PrimaryActionButton from '../../../common/Buttons/PrimaryActionButton'
import * as commonStyles from '../../../common/_common.scss'
import DisabledEditProfileButton from '../../../common/forms/DisabledEditProfileButton'
import PropTypes from 'prop-types';

class AdviserProfile extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    editAll: PropTypes.func.isRequired,
    editingProfile: PropTypes.bool.isRequired,
    submitProfile: PropTypes.func.isRequired,
    submittingProfile: PropTypes.bool.isRequired,
    submittedProfile: PropTypes.bool.isRequired,
    cancelEditingProfile: PropTypes.func.isRequired,
    edited: PropTypes.bool.isRequired,
    stopEditing: PropTypes.func.isRequired,
    containerIsValid: PropTypes.bool.isRequired,
    hasPendingProfile: PropTypes.bool,
    showModal: PropTypes.bool,
    showProfileLockedModal: PropTypes.func,
    hideProfileLockedModal: PropTypes.func
  };

  render () {
    const profile = this.props.profile
    return (
      <Row>
        <Col sm={4} md={3} lg={3} className="d-none d-sm-block">
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              <AdviserProfilePicturesEditor
                profile={profile}
                profilePicture={profile.profilePic}
                companyLogo={profile.companyLogo}
              />
            </Col>
          </Row>
          {this.props.editingProfile && (
            <Row>
              <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
                <AdviserProfileContactDetailsEditor profile={profile} />
              </Col>
            </Row>
          )}
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              <AdviserProfileLanguagePreferencesEditor profile={profile} />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              <AdviserProfileAreasOfSpecialisationEditor profile={profile} />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              <AdviserProfileClientTypesEditor profile={profile} />
            </Col>
          </Row>
        </Col>
        <Col sm={8} md={9} lg={9} className="d-none d-sm-block">
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              <AdviserProfileBlurbEditor profile={profile}>
                {this.props.hasPendingProfile ? <DisabledEditProfileButton
                  buttonText={this.props.hasPendingProfile ? 'Pending approval' : 'Edit'}
                  size={'lg'}
                  onClick={this.props.hasPendingProfile ? this.props.showProfileLockedModal : this.props.editAll} />
                  : <EditProfileButton
                    buttonText={this.props.hasPendingProfile ? 'Pending approval' : 'Edit'}
                    size={'lg'}
                    onClick={this.props.hasPendingProfile ? this.props.showProfileLockedModal : this.props.editAll}
                    isDisabled={this.props.hasPendingProfile} />
                }
              </AdviserProfileBlurbEditor>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              <AdviserProfileInvestmentMinimumsEditor profile={profile} />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              <AdviserProfileEducationEditor
                editingProfile={this.props.editingProfile}
                profile={profile}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              <AdviserProfileWorkExperienceEditor
                editingProfile={this.props.editingProfile}
                profile={profile}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              <AdviserProfileConflictDeclarationsEditor profile={profile} />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={12} lg={12} className="d-none d-sm-block">
              {!this.props.editingProfile && (
                <AdviserProfileSubmitForApproval
                  profile={profile}
                  containerIsValid={this.props.containerIsValid}
                  edited={this.props.edited}
                  isSubmitting={this.props.submittingProfile}
                 />
              )}
              {this.props.editingProfile && (
                <EditButton
                  stopEditing={() => {
                    this.props.stopEditing()
                    this.props.submitProfile(this.props.profile)
                  }}
                  formIsValid={this.props.edited}
                  submitting={this.props.submittingProfile}
                  cancelEditing={this.props.cancelEditingProfile}
                  editing
                />
              )}
            </Col>
          </Row>
        </Col>
        <Modal
          show={this.props.showModal}
          aria-labelledby='contained-modal-title' >
          <Modal.Header style={{ borderBottom: 'none', paddingLeft: '40px', paddingRight: '40px', paddingTop: '40px' }}>
            <h2>Profile pending approval</h2>
          </Modal.Header>
          <Modal.Body style={{ paddingLeft: '40px', paddingRight: '40px', paddingBottom: '10px' }}>
            <p style={{ fontSize: '16px', marginBottom: '12px' }}>Your profile is currently pending approval.</p>
            <p style={{ fontSize: '16px', marginBottom: '0' }}>Once your latest changes have been approved, you will be able to edit your profile.</p>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: 'none', paddingLeft: '40px', paddingRight: '40px', paddingBottom: '40px' }}>
            <PrimaryActionButton
              className={commonStyles['delete-confirmation-modal-button']}
              buttonText='Close'
              onClick={() => {
                this.props.hideProfileLockedModal()
              }}
            />
          </Modal.Footer>
        </Modal>
      </Row>
    )
  }
}

export default  (AdviserProfile)
